import { useEffect, useState } from "react"
import { FaFilter } from "react-icons/fa"

const ValidatedTrendsFilters = ({ filters, setFilters }) => {

  const [showFilters, setShowFilters] = useState(false)
  const [countValues, setCountValues] = useState([])
  const [weekValues, setWeekValues] = useState([])
  useEffect(() => {
    const values = []
    const weekValues = []
    for (let i = 1; i <= 200; i++) {
      if (i < 52) {
        weekValues.push(i)
      }
      values.push(i)
    }
    setCountValues(values)
    setWeekValues(weekValues)
  }, [])

  return <div className="relative">
    <button onClick={() => {
      setShowFilters(prev => !prev)
    }} className=""><FaFilter />    </button>

    {showFilters ? <>
      <div className="min-w-40 lg:min-w-80 rounded absolute p-4 top-full right-0 lg:right-1/2 lg:translate-x-1/2 bg-white border-slate-300 text-xs border-2 z-20" id="filter-validated-trends-popup">
        Minimum <select value={filters.minProducts} className="border p-2 rounded"
          onChange={e => {
            setFilters(prev => {
              return { ...prev, minProducts: e.target.value }
            })
          }}
        >
          {
            countValues.map(item => <option key={`${item}`} value={`${item}`}>{item}</option>)
          }
        </select> products in <select
          value={filters.weeks}
          className="border p-2 rounded"
          onChange={e => {
            setFilters(prev => {
              return { ...prev, weeks: e.target.value }
            })
          }}
        >
          {
            weekValues.map(item => <option key={`${item}`} value={`${item}`}>{`${item}`}</option>)
          }
        </select> Weeks.
      </div>
      <div className="fixed w-screen h-screen bg-white/0 top-0 left-0" onClick={() => {
        setShowFilters(false)
      }}></div>
    </>
      : null}
  </div>
}

export default ValidatedTrendsFilters
